import {Component, OnInit} from '@angular/core';
import {environment} from "../environments/environment";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ProjectsService} from "./shared/services/projects.service";
import {CoreService} from "./shared/services/core.service";
import {ToastrService} from 'ngx-toastr';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

declare global{
  interface Window {
    _paq: any[];
  }
}

const themeCssURL = environment.themesCSSUrl;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit{
  public title = 'AdvoFin Prozessfinanzierungs AG - Registrierung';


  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private projectService: ProjectsService,
    private coreService: CoreService,
    private toastr: ToastrService
  ) {
    translate.setDefaultLang('de');
    this.coreService.disableThankYouPage();
    this.coreService.enableSidebar();
  }
  ngOnInit() {
   this.route.queryParams.subscribe( params => {
      if(params['lang']) {
        this.translate.use(params['lang']);
      }
     }
   );
  }
}
